var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9541 9.47595C8.1159 9.47595 7.29655 9.2274 6.59961 8.76172C5.90267 8.29604 5.35958 7.63426 5.03882 6.85986C4.71805 6.08547 4.63408 5.23335 4.79761 4.41126C4.96113 3.58916 5.36458 2.83403 5.95728 2.24133C6.54997 1.64864 7.30511 1.24495 8.1272 1.08142C8.94929 0.917898 9.80153 1.00187 10.5759 1.32263C11.3503 1.6434 12.0121 2.18661 12.4778 2.88355C12.9435 3.58048 13.1921 4.39984 13.1921 5.23804C13.1908 6.36162 12.744 7.43879 11.9495 8.23328C11.155 9.02777 10.0777 9.47463 8.9541 9.47595ZM1.00122 16.8881H16.365V15.442C16.365 14.1955 15.8699 13.0001 14.9885 12.1187C14.1071 11.2372 12.9116 10.7419 11.665 10.7419H5.7002C4.45368 10.7419 3.25813 11.2372 2.37671 12.1187C1.49529 13.0001 1 14.1955 1 15.442L1.00122 16.8881Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccIcon);
export default __webpack_public_path__ + "static/media/accIcon.bb5143cba3d77f6a9847f1d3de103a84.svg";
export { ForwardRef as ReactComponent };